import { Paragraph2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

import { StoreCardSection } from "./StoreCardSection"

import RocketIcon from "@bounce/assets/icons/Rocket.svg"

export const StoreCardReservationsSection = ({ reservationCount }: { reservationCount?: number }) => {
  const { t } = useTranslation()

  if (!reservationCount || reservationCount <= 0) {
    return null
  }

  return (
    <StoreCardSection icon={RocketIcon}>
      <Paragraph2 className="!text-[0.875rem]">
        {t(
          "cmp.storeCard.reservationsPerWeekLabel",
          "{count, plural, =1 {# booking in the last week} other {# bookings in the last week}}",
          { count: reservationCount },
        )}
      </Paragraph2>
    </StoreCardSection>
  )
}
